/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Radio } from 'antd';

// Misc imports
import { CONVERSATION_STATUSES } from '../../../constants/liveChat';

const LiveChatStatusFilter = ({ ...formItemProps }) => {
  const { t } = useTranslation();
  const [, updateState] = useState(); // Hook to force a component re-render

  const handleOnChange = (status) => {
    // Trigger the formItemProps.onChange if it exists
    if (formItemProps.onChange) {
      formItemProps.onChange(status);
    }

    updateState(status);
  };

  return (
    <Fragment>
      <Radio.Group
        className="d-flex flex-column"
        options={[
          {
            label: t('All Statuses'),
            value: `${CONVERSATION_STATUSES.STARTED},${CONVERSATION_STATUSES.FINISHED}`,
            style: { marginBottom: 4 }
          },
          {
            label: t('Open Conversations'),
            value: CONVERSATION_STATUSES.STARTED,
            style: { marginBottom: 4 }
          },
          {
            label: t('Closed Conversations'),
            value: CONVERSATION_STATUSES.FINISHED,
            style: { marginBottom: 4 }
          }
        ]}
        onChange={(e) =>
          handleOnChange(e.target.value)
        }
        {...formItemProps}
      />
    </Fragment>
  );
};

export default LiveChatStatusFilter;
